import { useLoaderData } from '@muse-web/router'

import type { TAudioScreenLoaderData } from '../types/audioScreenLoaderTypes'

export const useAudioScreenLoaderData = useLoaderData<TAudioScreenLoaderData>
